const statusEnum = Object.freeze({
    ACTIVE: 5,
    INACTIVE: 10
});
export default statusEnum;
